module.exports = __webpack_public_path__ + "img/bg-overlay.30dd9a04.png";